const ARRAY_TYPE_PARAMS = [
  'company',
  'employmentType',
  'careerLevel',
  'discipline',
  'industry',
  'benefit',
  'country',
  'city',
  'remoteOption',
];

export const getVisionTypeParams = (search: string): string => {
  const searchParams = new URLSearchParams(search);

  // Transform `param=1&param=2` to `param=1-2`, to use the Crate format
  ARRAY_TYPE_PARAMS.forEach((name) => {
    const values = searchParams.getAll(name);

    if (values.length > 1) {
      searchParams.set(name, values.join('-'));
    }
  });

  return searchParams.toString();
};
